$(document).ready(function(){
	if (window.location.hash === '') {
        // 默认展示第一个文章
        var firstArticle = $('.hcarticle').first();  // 获取第一个 hcarticle 元素
        var firstHashId = firstArticle.attr('href') ? firstArticle.attr('href').substr(1) : firstArticle.data('target').substr(1);
        var firstHrefTag = $('.panel a[href="#' + firstHashId + '"]') || $('.panel a[data-target="#' + firstHashId + '"]');

        // 打开第一个文章
        firstArticle.addClass('s4com-active');
        firstHrefTag.removeClass('collapsed');  // 移除 collapsed 类
        $('#' + firstHashId).addClass('in');  // 添加 in 类来显示内容
        history.pushState(null, null, '#' + firstHashId);  // 更新 URL 中的哈希值
    }
  	$(window).on('hashchange', function () {
		let url = window.location.href;
		let currentHashId;

		if (url.includes('!')) {
			currentHashId = window.location.hash.slice(1).substring(1, window.location.hash.slice(1).length);
		} else {
			currentHashId = window.location.hash.slice(1).substring(0, window.location.hash.slice(1).length);
		}
        console.log("currentHashId: "+ currentHashId);
		let articleHrefTag = $('.panel a[href="#' + currentHashId + '"]');
		if (articleHrefTag.length === 0) {
			articleHrefTag = $('.panel a[data-target="#' + currentHashId + '"]');
		}

		if (articleHrefTag.parents('.s4com-section-body').length) {
			articleHrefTag.parents('.s4com-section-body:first').removeClass('collapse').addClass('in');
		}

		if (articleHrefTag.length && location.hash.indexOf('#q=') < 0) {
			articleHrefTag.removeClass('collapsed');
			$('#' + currentHashId).addClass('in');

			articleHrefTag.parents('.s4com-section-body:first').parents('.panel').find('.hcsection').removeClass('collapsed').addClass('in');
			articleHrefTag.parents('.panel-heading:first').find('.hcarticle').removeClass('collapsed').addClass('s4com-active');

			if ($('.categories-list').length) {
				articleHrefTag.parents('.tab-pane:first').addClass('active')
					.siblings().removeClass('active');
				const categoryTag = articleHrefTag.parents('.tab-pane').attr('id');
				if ($('[href="#' + categoryTag + '"]').length > 1) {
					$('[href="#' + categoryTag + '"]').parents('.categories-list-item').addClass('active')
						.siblings().removeClass('active');
				} else {
					$('[data-target="#' + categoryTag + '"]').parents('.categories-list-item').addClass('active')
						.siblings().removeClass('active');
				}
			}

			if ($('.sections-list').length) {
				articleHrefTag.parents('.tab-pane:first').addClass('active');
				const categoryTag = articleHrefTag.parents('.tab-pane').attr('id');
				if ($('[href="#' + categoryTag + '"]').length > 1) {
					$('[href="#' + categoryTag + '"]').parents('.sections-list-item').addClass('active')
						.siblings().removeClass('active');
				} else {
					$('[data-target="#' + categoryTag + '"]').parents('.sections-list-item').addClass('active')
						.siblings().removeClass('active');
				}
			}
			$('html, body').animate({
				scrollTop: articleHrefTag.offset().top - 50
			});
		} else if (!articleHrefTag.length || location.hash.indexOf('#q=') === 0) {
			if ($('.hc-theme-6').length || $('.hc-theme-7').length) {
				$('.categories-list .categories-list-item').first().addClass('active').siblings().removeClass('active');
				$('.s4com-tab-content .tab-pane').first().addClass('active').siblings().removeClass('active');
			}
		}

	});

    if (window.location.hash === '') {
		$('.categories-list .categories-list-item').first().addClass('active');
		$('.s4com-tab-content .tab-pane').first().addClass('active');
	}

	$('.hcarticle').click(function (e) {
		e.preventDefault();
		var article = $(this);
		var id = article.attr('href') || article.data('target');
        var hashId = id.substr(1);
        var hrefTag = $('.panel a[href="#' + hashId + '"]') || $('.panel a[data-target="#' + hashId + '"]');


		article.removeClass('s4com-active');
        $('.panel-title .hcarticle').addClass('collapsed');
        $('.panel-collapse').removeClass('in');
		if (article.hasClass('s4com-active')) {
			article.removeClass('s4com-active');
          hrefTag.addClass('collapsed');
          $('#' + hashId).removeClass('in');
			history.pushState("", document.title, window.location.pathname + window.location.search);
		} else {
		  article.addClass('s4com-active');
          hrefTag.removeClass('collapsed');
		  article.removeClass('collapsed');
          $('#' + hashId).addClass('in');
			history.pushState(null, null, '#' + hashId);
		}
	});
  $('.hcsection').click(function (e) {
    e.preventDefault();
    var that = $(this);
    var id = that.attr('href') || that.data('target');
    var hashId = id.substr(1);
    if (that.hasClass("collapsed")) {
      that.removeClass("collapsed");
      $('#' + hashId).addClass('in');
    } else {
      that.addClass("collapsed");
      $('#' + hashId).removeClass('in');
    }
  });
  $(".categories-list-item .hccategory a.nav-link").click(function (e) {
    e.preventDefault();
    var that = $(this);
    var id = that.attr('href') || that.data('target');
    var hashId = id.substr(1);
    $(".categories-list-item").removeClass("active");
    that.parents(".categories-list-item").addClass("active");
    $(".tab-pane").removeClass("active");
    $('#' + hashId).addClass('active');
  });

	$('.hccategory a').on('click', function() {
		if ($(window).width() <= 768) {
			$('html, body').animate({
				scrollTop: $('.s4com-tab-content').offset().top - 50
			});
		}
	});
	var $inputfield = $('#s4com-q');
	$inputfield.autocomplete({
      lookup: faqList,
      onSelect: function (suggestion) {
        console.log('You selected: ' + suggestion.value + ', ' + suggestion.data);
        if (window.location.hash === '' || window.location.hash !== suggestion.data) {
			setTimeout(function () {
				[...document.getElementsByClassName('s4com-section-body')].forEach(el=>{el.style.height = 'auto'})
				history.pushState(null, null, `#${suggestion.data}`);
				$(window).trigger('hashchange');
			}, 5);
		}
      }
    });
  
	// Hash with search phrase
	if (location.hash && location.hash.indexOf('#q=') === 0) {
		var q = decodeURIComponent(location.hash.substring(3));
		$inputfield.val(q).trigger('keyup');

		if ($('.hc-theme-6').length || $('.hc-theme-7').length) {
			$('.categories-list .categories-list-item').first().addClass('active').siblings().removeClass('active');
			$('.s4com-tab-content .tab-pane').first().addClass('active').siblings().removeClass('active');
		}
	}

	// Hash with article id
	if((window.location.hash != "") && (window.location.hash.indexOf('#q') == -1)) {
		$(window).trigger('hashchange');
	}
});